export default function Header() {
    return (
        <div id='header'>
            <div id='logo'>
                <a href='/'>
                    <img src='/spotify_logo.png' alt='Spotify' />
                    <span>Proxy</span>
                </a>
            </div>            
        </div>
    );
}
